import env from 'enviro';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useIsInternalHubspotUser, useUserInfoLoading } from './hooks/useUserInfo';
import { AddOnsPage } from './pages/add-ons/AddOnsPage';
import { ContentHubPage } from './pages/content/ContentHubPage';
import { CustomerPlatformPage } from './pages/customer-platform/CustomerPlatformPage';
import { DataHubPage } from './pages/data/DataHubPage';
import { FreeToolsPage } from './pages/free/FreeToolsPage';
import { MarketingHubPage } from './pages/marketing/MarketingHubPage';
import { SalesHubPage } from './pages/sales/SalesHubPage';
import { ServiceHubPage } from './pages/service/ServiceHubPage';

// NOTE: DO NOT USE THIS COMPONENT FOR PRODUCTION CODE
// This is a temporary component to enable development of the new pricing page
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PricingPageRoutes = () => {
  const isInternalHubspotUser = useIsInternalHubspotUser();
  const isUserInfoLoading = useUserInfoLoading();
  const match = useRouteMatch();
  if (env.isProd() || !isUserInfoLoading && !isInternalHubspotUser) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: "/marketing"
    });
  }
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: `${match.path}/marketing`,
      component: MarketingHubPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${match.path}/sales`,
      component: SalesHubPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${match.path}/service`,
      component: ServiceHubPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${match.path}/content`,
      component: ContentHubPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${match.path}/data`,
      component: DataHubPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${match.path}/add-ons`,
      component: AddOnsPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${match.path}/suite`,
      component: CustomerPlatformPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${match.path}/crm`,
      component: FreeToolsPage
    })]
  });
};